import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IconButton } from '@mui/material';
import CustomModal from './CustomModal';


function createData(number, type, createdDate, lastPaid, total, status, icon) {
    return { number, type, createdDate, lastPaid, total, status, icon };
}



export default function CustomDoctorTable(props) {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: props.color?props.color:'#59776F',
            color: theme.palette.common.white,
            fontFamily: "'Tajawal', sans-serif",
            fontSize:14,
            
            paddingBottom:5,
            paddingTop:5,
            paddingLeft:5,
            paddingRight:5
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 12,
            color: '#FFFFFF',
            fontFamily: "'Tajawal', sans-serif",
            
            paddingBottom:0,
            paddingTop:0,
            paddingLeft:10,
            paddingRight:10
        },
       
    }));
    
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#FFFFFF',
    
        },
        '&:nth-of-type(even)': {
            backgroundColor: props.color?props.color:'#59776F',
    
        },
        '&:nth-of-type(odd) td': {
    
            color: '#000000'
        },
        '&:nth-of-type(even) td': {
    
            color: '#FFFFFF'
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const rows = [
        createData('#000001', 'invoice type 1', '12/05/2022', '30/05/2022', '999,500 IQD', 'لم يتم التسديد', <IconButton onClick={() => { setOpen(true) }}> <VisibilityIcon sx={{ color: props.color?props.color:"#2E5266" }} /></IconButton>),
        createData('#000002', 'invoice type 2', '12/05/2022', '30/05/2022', '999,500 IQD', ' تم التسديد', <IconButton onClick={() => { setOpen(true) }}> <VisibilityOutlinedIcon sx={{ color: "#FFFFFF" }} /> </IconButton>),
        createData('#000003', 'invoice type 1', '12/05/2022', '30/05/2022', '999,500 IQD', 'لم يتم التسديد', <IconButton onClick={() => { setOpen(true) }}> <VisibilityIcon sx={{ color: props.color?props.color:"#2E5266" }} /></IconButton>),
        // createData('#000004', 'invoice type 2', '12/05/2022', '30/05/2022', '999,500 IQD', 'لم يتم التسديد', <IconButton onClick={() => { setOpen(true) }}> <VisibilityOutlinedIcon sx={{ color: "#FFFFFF" }} /></IconButton>),
        // createData('#000005', 'invoice type 3', '12/05/2022', '30/05/2022', '999,500 IQD', 'لم يتم التسديد', <IconButton onClick={() => { setOpen(true) }}> <VisibilityIcon sx={{ color: "#2E5266" }} /></IconButton>),
        // createData('#000006', 'invoice type 4', '12/05/2022', '30/05/2022', '999,500 IQD', 'لم يتم التسديد', <IconButton onClick={() => { setOpen(true) }}> <VisibilityOutlinedIcon sx={{ color: "#FFFFFF" }} /> </IconButton>),
        // createData('#000007', 'invoice type 4', '12/05/2022', '30/05/2022', '999,500 IQD', 'لم يتم التسديد', <IconButton onClick={() => { setOpen(true) }}> <VisibilityIcon sx={{ color: "#2E5266" }} /> </IconButton>),
        // createData('#000008', 'invoice type 4', '12/05/2022', '30/05/2022', '999,500 IQD', 'لم يتم التسديد', <IconButton onClick={() => { setOpen(true) }}> <VisibilityOutlinedIcon sx={{ color: "#FFFFFF" }} /> </IconButton>),
    
    ];
    return (
        <>
        <TableContainer sx={{
            boxShadow:'#00000055 0px 6px 12px',
            borderStyle: 'solid', borderRadius: '15px', borderColor: '#707070',borderWidth:'1px'

        }} component={Paper} >
            <Table sx={{ minWidth: 700,  }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="right">رقم الفاتورة</StyledTableCell>
                        <StyledTableCell align="right">اسم الفاتورة</StyledTableCell>
                        <StyledTableCell align="right">تاريخ الانشاء</StyledTableCell>
                        <StyledTableCell align="right">اخر موعد للتسديد</StyledTableCell>
                        <StyledTableCell align="right">المبلغ الكلي للفاتورة</StyledTableCell>
                        <StyledTableCell align="right">حالة الفاتورة</StyledTableCell>
                        <StyledTableCell align="center">عرض الفاتورة</StyledTableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (

                        <StyledTableRow key={row.number}>
                            <StyledTableCell align="right">
                                {row.number}
                            </StyledTableCell>
                            <StyledTableCell align="right">{row.type}</StyledTableCell>
                            <StyledTableCell align="right">{row.createdDate}</StyledTableCell>
                            <StyledTableCell align="right">{row.lastPaid}</StyledTableCell>
                            <StyledTableCell align="right">{row.total}</StyledTableCell>
                            <StyledTableCell align="right">{row.status}</StyledTableCell>
                            <StyledTableCell align="center">{row.icon}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        <CustomModal handleClose={handleClose} open={open} handleOpen={handleOpen}/>
        </>
    );
}
